import { useSelector } from 'react-redux';
import classes from './DownloadExel.module.css'
import { useParams } from 'react-router-dom';
import { exportXlsx } from '../../../../../../../utils'
import { onKeyDown } from "../../../../../../../service";

const DownloadExel = ({studentsSubmmissionList , setMsg}) => {
    const texts = useSelector(state => state.translate.texts);
    const { topics } = useSelector(state => state.topics)
    const { guid, id } = useParams();
    const { courses } = useSelector(state => state.courses);
    
    
    const exportFiles = () => {
        if (!studentsSubmmissionList.students?.length) {
            setMsg(<div className={classes.DownloadMsg}> {texts.noDataToView}</div>)
            return
        }
        let arr = [], current, filename, headerNames;
        if (studentsSubmmissionList.students.length) {
            topics?.forEach(t => {
                if (!current) {
                    current = t.children.find(c => c.id === guid);
                    if (current) {
                        filename = current.name;
                        headerNames = [texts.studentName, ...studentsSubmmissionList.assessments.map(a => a.name)];
                    }
                }
                t.children?.forEach(tt => {
                    if (!current) {
                        current = tt.children.find(c => c.id === guid);
                        if (current) {
                            filename = current.name;
                            headerNames = [texts.studentName, ...studentsSubmmissionList.assessments?.map(a => texts[a.name])];
                        }
                    }
                })
            })
            if (!filename) {
                filename = courses?.find(x => x.id == id)?.name;
                headerNames = [texts.studentName, ...studentsSubmmissionList.assessments.map(a => a.name)];
            }
            studentsSubmmissionList.students.forEach(u => {
                let obj = { [texts.name]: u.firstName + ' ' + u.lastName }
                arr.push(obj)
                studentsSubmmissionList.assessments.forEach((_a, index) => {
                    obj[index] = u.submissions[_a.id].status == "Completed" ? Math.round(u.submissions[_a.id].score * 100 * 10) / 10 : null;
                })
            })
            exportXlsx(`${filename} ${texts.scores}`, [headerNames], arr);
        }
    }
    return (
        <div className={classes.DownloadIcon} onClick={exportFiles} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, exportFiles)}></div>
    )
}
export default DownloadExel